// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 394 ? "core_account" : chunkId) + "." + {"168":"3bc3ee85","394":"04133055"}[chunkId] + ".js";
};